/* eslint-disable */
import { node } from "~/util/dom";

interface IDialogButtonOptions extends HTMLButtonElement {
	primary?: boolean;
}

export function createDialogButton({
	primary = false,
	className = "",
	...rest
}: Partial<IDialogButtonOptions>): HTMLButtonElement {
	const button = node("button", {
		type: "button",
		className: `ui-dialogButton ${primary ? "ui-dialogButton--primary" : ""} ${className}`,
		...rest,
	});

	return button;
};
